/**
 * GSAP ScrollTrigger — Subtle slide-up-on-scroll
 * Uses fromTo with ScrollTrigger so GSAP handles hide/show automatically.
 * Staggers children in grid/flex sections. No manual pre-hiding.
 */
(function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);

  var SKIP_IDS = ['header', 'footer', 'announcement', 'announcment', 'topbar',
    'ajax-cart', 'menu-drawer', 'predictive-search', 'breadcrumb'];

  function shouldSkip(wrapper) {
    var id = wrapper.id || '';
    for (var i = 0; i < SKIP_IDS.length; i++) {
      if (id.indexOf(SKIP_IDS[i]) !== -1) return true;
    }
    if (wrapper.querySelector('#hero')) return true;
    if (wrapper.closest('.shopify-section-group-header-group') ||
        wrapper.closest('.shopify-section-group-footer-group')) return true;
    return false;
  }

  function getVisibleRoot(wrapper) {
    var children = wrapper.children;
    for (var i = 0; i < children.length; i++) {
      var tag = children[i].tagName.toLowerCase();
      if (tag !== 'script' && tag !== 'style' && tag !== 'link' && tag !== 'template') {
        return children[i];
      }
    }
    return null;
  }

  /* Only skip for elements in the top 25% of viewport (true above-fold) */
  function isVisible(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.25;
  }

  /* Find staggerable children: direct visible children of a flex/grid container */
  function getStaggerItems(el) {
    var container = el;
    /* Look one level deep for a flex/grid wrapper */
    var firstChild = el.children[0];
    if (firstChild && firstChild.children.length >= 3) {
      var style = window.getComputedStyle(firstChild);
      if (style.display === 'flex' || style.display === 'grid' ||
          style.display === 'inline-flex' || style.display === 'inline-grid') {
        container = firstChild;
      }
    }
    /* Also check el itself */
    var elStyle = window.getComputedStyle(el);
    if (elStyle.display === 'flex' || elStyle.display === 'grid') {
      container = el;
    }

    var items = [];
    for (var i = 0; i < container.children.length; i++) {
      var child = container.children[i];
      var tag = child.tagName.toLowerCase();
      if (tag !== 'script' && tag !== 'style') {
        items.push(child);
      }
    }
    return items.length >= 3 ? items : null;
  }

  function animateSliderCards(splideEl) {
    var list = splideEl.querySelector(':scope > .splide__track > .splide__list');
    if (!list) return;
    var slides = list.querySelectorAll(':scope > .splide__slide');
    if (!slides.length) return;

    var toAnimate = [];
    slides.forEach(function (s) {
      if (!s.dataset.gsapChild) {
        s.dataset.gsapChild = '1';
        toAnimate.push(s);
      }
    });
    if (!toAnimate.length) return;

    /* Card + content fade-in handled by CSS keyframes for instant load */
  }

  function waitForSplide(splideEl) {
    if (splideEl.classList.contains('is-initialized')) {
      animateSliderCards(splideEl);
      return;
    }
    var attempts = 0;
    var check = setInterval(function () {
      attempts++;
      if (splideEl.classList.contains('is-initialized')) {
        clearInterval(check);
        animateSliderCards(splideEl);
      } else if (attempts > 30) {
        clearInterval(check);
      }
    }, 100);
  }

  function initAnimations() {
    var wrappers = document.querySelectorAll('.shopify-section');

    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.gsapInit) return;

      var el = getVisibleRoot(wrapper);

      if (shouldSkip(wrapper) || !el) {
        /* Skipped section — reveal it (was hidden by gsap-prehide CSS) */
        if (el) el.style.opacity = '1';
        wrapper.dataset.gsapInit = '1';
        return;
      }
      wrapper.dataset.gsapInit = '1';

      var splides = el.querySelectorAll('.splide:not(.splide .splide)');

      if (splides.length > 0) {
        /* Parent must be visible — GSAP animates the slides, not the container */
        el.style.opacity = '1';

        /* Section header */
        var header = el.querySelector('.Section_header, .Section_header_left');
        if (header && !header.dataset.gsapChild && !isVisible(header)) {
          header.dataset.gsapChild = '1';
          gsap.fromTo(header,
            { y: 18, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.4, ease: 'power2.out',
              scrollTrigger: { trigger: header, start: 'top 95%', once: true } }
          );
        }

        splides.forEach(function (s) { waitForSplide(s); });

      } else {
        /* Non-slider section — above-fold: just reveal */
        if (isVisible(el)) {
          el.style.opacity = '1';
          return;
        }

        /* Try to find staggerable children (flex/grid items) */
        var items = getStaggerItems(el);
        if (items) {
          var triggerConfig = { trigger: el, start: 'top 95%', once: true };
          items.forEach(function (item, index) {
            gsap.fromTo(item,
              { opacity: 0, y: 18 },
              { opacity: 1, y: 0, clearProps: 'transform',
                duration: 0.4, delay: index * 0.08, ease: 'power2.out',
                scrollTrigger: triggerConfig }
            );
          });
        } else {
          /* Single block — animate as one */
          gsap.fromTo(el,
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.5, ease: 'power2.out',
              scrollTrigger: { trigger: el, start: 'top 95%', once: true } }
          );
        }
      }
    });

    /* Remove the pre-hide stylesheet now that GSAP has taken over */
    var prehide = document.getElementById('gsap-prehide');
    if (prehide) prehide.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

  document.addEventListener('shopify:section:load', function () {
    ScrollTrigger.refresh();
    initAnimations();
  });
})();
